export default __webpack_public_path__ + "static/GooglePlayIconDark-60abae2e687c3497a630d6e6e613040b.svg";